import React, { useState, useEffect, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import {toast} from "react-toastify";
import { data } from 'jquery';

const SiteIncentiveList = ({
    getAllIncentives,
    incentives,
    history,
    match,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [remark, setRemark] = useState("");
  const [closed, setClosed] = useState(false);
  const handleModalHide = () => {
    setIsModal(false);
    window.location.reload();
  }
  
  useEffect(() => {
    if (getAllIncentives !== null){
        (async () => {
            setIsLoading(true);
            await getAllIncentives(1);
            setIsLoading(false);
          })();
    }
  },[getAllIncentives]);

  useEffect(() => {
    if (closed === true){
        window.location.reload();
    }
  },[closed]);

  const approveRejectIncentive = (id,status,val) => {
      if(id && id !== undefined) {   
        console.log('Approve Incentive' + id);
        const payload = {
          'id': id,
          'status': status
        }; 
        //console.log(payload); return false;
        setIsLoading(true);
        (async() => {       
         const url = `${Config.postSales.approveOrRejectIncentive}`;   
         const { data } = await axios.post(url,payload);
         const res = data?.response?.data;
         if(res === true) {
            setIsLoading(false);
            toast.success('Incentive '+val+' successfully.');
            setTimeout(() => window.location.reload(true), 3000);
         } else {
            setIsLoading(false);
            toast.success('Incentive not '+val+' successfully.');
         }
        })(); 
      }
  }

  const headers = [
    'Site',
    'Incentive For', 
    'Incentive Amount', 
    'User',
    'User Incentive(%)',
    'User Incentive Amount',
    'User Payment Status',
    'Senior',
    'Senior Incentive(%)',
    'Senior Incentive Amount',
    'Senior Payment Status',
    'Head',
    'Head Incentive(%)',
    'Head Incentive Amount',
    'Head Payment Status',
    'Created By',
    'Created',
    'Sales Staus',
    'Finance Status',
    'Approve/Reject',
    'Action' 
  ];

  useEffect(() => {
    const tableData = [
        'id',
        'site_name',
        'incentive_for', 
        'incentive_amount', 
        'user_name',
        'user_incentive_percentage',
        'user_incentive',
        'user_utr_no',
        'senior_name',
        'senior_incentive_percentage',
        'senior_incentive',
        'senior_utr_no',
        'head_name',
        'head_incentive_percentage',
        'head_incentive',
        'head_utr_no',
        'created_by_user',
        'created_at',
        'sales_status',
        'finance_status',
        'Approve/Reject',
        'Action' 
    ];
    //console.log(incentives.data);
    if (incentives && incentives?.data && incentives?.data.length > 0) {
        const data = incentives.data.map((element) =>
            Object.assign(
                {},
                ...tableData.map((key) => ( 
                    (key === 'sales_status' && element['sales_status'] === 1) ? 
                    {[key]: 'Approved'} : (key === 'sales_status' && element['sales_status'] === 2) ? 
                    {[key]: 'Rejected'} : (key === 'sales_status' && element['sales_status'] === 0) ? 
                    {[key]: 'Pending'} : (key === 'finance_status' && element['finance_status'] === 0) ? 
                    {[key]: 'Pending'} : (key === 'finance_status' && element['finance_status'] === 1) ? 
                    {[key]: 'Approved'} : (key === 'finance_status' && element['finance_status'] === 2) ? 
                    {[key]: 'Rejected'} : (key === 'finance_status' && element['finance_status'] === 3) ? 
                    {[key]: 'Hold'} : (key === 'user_name' && element['user_name'] === null) ? 
                    {[key]: 'NA'} : (key === 'senior_name' && element['senior_name'] === null) ? 
                    {[key]: 'NA'} : (key === 'head_name' && element['head_name'] === null) ? 
                    {[key]: 'NA'} : (key === 'user_utr_no' && element['user_utr_no'] === null && element['user_name'] === null) ? 
                    {[key]: 'NA'} : (key === 'user_utr_no' && element['user_utr_no'] === null && element['user_name'] !== null) ? 
                    {[key]: 'Unpaid'} : (key === 'user_utr_no' && element['user_utr_no'] !== null && element['user_name'] !== null) ? 
                    {[key]: 'Paid'} : (key === 'senior_utr_no' && element['senior_utr_no'] === null && element['senior_name'] === null) ? 
                    {[key]: 'NA'} : (key === 'senior_utr_no' && element['senior_utr_no'] === null && element['senior_name'] !== null) ? 
                    {[key]: 'Unpaid'} : (key === 'senior_utr_no' && element['senior_utr_no'] !== null && element['senior_name'] !== null) ? 
                    {[key]: 'Paid'} : (key === 'head_utr_no' && element['head_utr_no'] === null && element['head_name'] === null) ? 
                    {[key]: 'NA'} : (key === 'head_utr_no' && element['head_utr_no'] === null && element['head_name'] !== null) ? 
                    {[key]: 'Unpaid'} : (key === 'head_utr_no' && element['head_utr_no'] !== null && element['head_name'] !== null) ? 
                    {[key]: 'Paid'} : (key === 'created_by_user' && element['created_by_user'] === null) ? 
                    {[key]: 'Auto'} : (key === 'site_name' && element['site_no'] !== null) ? 
                    {[key]: element['site_name']+'('+element['site_no']+')'} : (key === 'Approve/Reject' &&(element['sales_status'] === 1 || element['sales_status'] === 2)) ? 
                    {[key]: 'No'} : {[key]: element[key]}           
                    )
                ),
                {
                  Action: [
                    {
                      name: 'Edit Incentive',
                      link: `${baseUrl}/edit_incentive/${element.site_id}`,
                    }
                  ]
                }
            )
        );  
        data && setListData(data);
        setPageCount(Math.ceil(incentives.total / incentives.per_page));
    }
  }, [incentives]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getAllIncentives(val.selected + 1);
    setIsLoading(false);
  };
  
  const updateApproval = async (data) => {
    setActionData(data);
    if (data.action === 'accept') {
      const payload = {
        id: data.actionObj.id,
        remarks: '',
        actionFor: 'Accept',
        status: 1
      }; 
      setIsLoading(true);
      (async() => {       
        const url = `${Config.postSales.approveOrRejectIncentive}`;   
        const { data } = await axios.post(url,payload);
        const res = data?.response?.data;
        if(res === true) {
           setIsLoading(false);
           setIsModal(true);
        } else {
           setIsLoading(false);
           toast.error('Incentive not approved successfully.');
        }
       })();
    } else {
      setIsModal(true);
      setIsLoading(false);
    }
  };

  const handleContinue = async () => {
    setIsModal(false);
    const payload = {
      id: actionData.actionObj.id,
      remarks: remark,
      actionFor: 'Reject',
      status: 2
    };
    setIsLoading(true);
    (async() => {       
      const url = `${Config.postSales.approveOrRejectIncentive}`;   
      const { data } = await axios.post(url,payload);
      const res = data?.response?.data;
      if(res === true) {
         setIsLoading(false);
         setClosed(true);
      } else {
         setIsLoading(false);
         toast.error('Incentive not rejected successfully.');
      }
     })();
  };

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Link to="/dashboard/site_incentive" onClick={func} className="btn btn-transparent">
          {localization.returnToIncentive}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </div>
    );
  };

  const headerBtns = () => {
    return (
        <div className="Pm-btn pm-btn-align">
            <Link
                to={`${baseUrl}/add_incentive`}  
                className="btn btn-primary d-none d-md-inline-block"
            >
                {localization.addIncentive}
                <img src={Images?.ArrowRight} alt=""></img>
            </Link>
        </div>
    )
  }

  return (
    <Layout
      title={localization.incentiveList}
      Buttons={headerBtns}
      isLoading={isLoading}
    >

    <div className="container-fluid">
      <div className="card mt-2">
        <div className="card-header">
          {localization.incentiveList}
        </div>
          <div className="card-header">
           <div className="card-body">
            <TableSection
              data={listData}
              isId={false}
              isMngId={false}
              headers={headers}
              pageCount={pageCount}
              onPageChange={onPageChange}
              onChange={(data) => {updateApproval(data)}}
              //detailList={listData && listData}
              srNo={incentives?.data?.from}
            />
           </div>
          </div>
        </div>
      </div>

      <ModalPop
          title={
          actionData && actionData.action === 'reject'
              ? localization.rejectConf
              : localization.conf
          }
          show={isModal}
          handleModalHide={handleModalHide}
          actionData={actionData}
      >
      {actionData && actionData.action === 'reject' ? (
      <Fragment>
          <div className="modal-body">
          <div className="text-center">
              <h5>{localization.rejectIncentive}</h5>
              <div className="form-group">
              <ConstantInput
                  label={localization.addRemark}
                  required
                  isStarRequired={true}
                  type="text"
                  handleChange={(val) => {
                  setRemark(val);
                  }}
              />
              </div>
              <Button
              className="btn btn-primary"
              onClick={handleContinue}
              disabled={!remark}
              >
              {localization.continue}{' '}
              <img src="../images/arrow-right.png" alt="" />
              </Button>
          </div>
          </div>
      </Fragment>
      ) : (
      <Fragment>
          {successIconBox(localization.approveIncentiveScccess, handleModalHide)}
      </Fragment>
      )}
      </ModalPop>
     
    </Layout>
  );
};

export default SiteIncentiveList;
